import createFetchTypes from '@app/utils/createFetchTypes';

export type ResponseField = {
	name: string;
	value: any;
};

export type LeadType = {
	id: string;
	responseFields: ResponseField[];
	workspace: string;
	location: string;
	formInstance: {
		form: {
			name: string;
		};
		formFields: {
			displayName: string;
			internalName: string;
		}[];
	};
	collectedIn: string;
	campaign?: string;
	aibot?: string;
	aiMessage?: {
		topics?: {
			name: string;
			parentTopic: string;
		}[];
	};
	deleted: boolean;
	createdAt: Date;
	updatedAt: Date;
	contact?: string;
	sourceUrl?: string;
};

const mainType = 'inquiry';

export const getInquiriesTypes = createFetchTypes(`${mainType}_GET_INQUIRIES`);

export const exportInquiriesTypes = createFetchTypes(
	`${mainType}_EXPORT_INQUIRIES`,
);
